import { combineReducers } from "redux";
import createReducer from "utils/createReducer";

import clusterprofile from "state/clusterprofile/reducers";
import * as game from "state/game/reducers";

import * as forms from "modules/form/reducer";
import * as list from "modules/list/reducer";
import * as fetcher from "modules/dataFetcher/reducer";
import * as asyncAction from "modules/asyncAction/reducer";

import * as entities from "./entities";
import * as modal from "./modal";

const location = {
  UPDATE_ROUTER_PARAMS(nextState, { params }) {
    nextState.params = params;
  },
};

export default () =>
  combineReducers({
    clusterprofile,
    game: createReducer(game),
    location: createReducer(location),
    entities: createReducer(entities),
    forms: createReducer(forms),
    list: createReducer(list),
    modal: createReducer(modal),
    fetcher: createReducer(fetcher),
    asyncAction: createReducer(asyncAction),
  });
